// Inline relationship-detail panel rendered inside the InvestigationSidebar.
//
// Shows the selected edge's properties. (Duplicate resolution no longer happens
// from the graph — candidate duplicates are reviewed on the Entity Resolution
// page via hidden review groups — so there is no longer a per-edge resolution
// tab here.) A projected edge (structured ingest) also offers its source rows.

import type { SelectedEdge } from '@/components/neo4j/cytoscape/types'
import { PropertiesTab } from '@/components/neo4j/shared/entity-details/PropertiesTab'
import { RelationshipFacts } from '@/features/analyst-facts/RelationshipFacts'
import { EdgeRowsButton } from '@/features/structured-ingest/EdgeRowsButton'

interface SidebarRelationshipDetailProps {
  caseId: string
  selectedEdge: SelectedEdge
}

export function SidebarRelationshipDetail({
  caseId,
  selectedEdge,
}: SidebarRelationshipDetailProps) {
  return (
    <div className="flex flex-col gap-2 border-t border-border/40 px-3 py-3">
      <EdgeRowsButton caseId={caseId} edge={selectedEdge} />
      <RelationshipFacts caseId={caseId} relationship={selectedEdge} />
      <div className="rounded-md border border-border/40 bg-background/40 p-2">
        <PropertiesTab
          caseId={caseId}
          selectedNode={null}
          selectedEdge={selectedEdge}
          fullNodeDetails={null}
          isLoadingNodeDetails={false}
        />
      </div>
    </div>
  )
}
